import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
    ExpandLessIcon,
    ExpandMoreIcon,
    withRouter
} from '../../../material-ui';
import MTabsButton from '../../view/MTabsButton';
import MDivider from '../../view/MDivider';
import Apis from '../../../network/Apis';
import MTabPanel from '../../view/MTabPanel';
import ChartCircle from './ChartCircle';
import MBasketChartItem from './MBasketChartItem';

import MovieStateFootBallTextLive from './MovieStateFootBallTextLive';
import MovieStateFootBallStatistics from './MovieStateFootBallStatistics';
import DataUtils from '../../../model/DataUtils';
import AppData from '../../../model/AppData';
import AppUtils from '../../../control/apputlis';
import { OpenBrowser } from '../../../control/ToName';


const ICON1 = require('../../../images/icons/huangpai.png');
const ICON2 = require('../../../images/icons/hongpai.png');
const ICON3 = require('../../../images/icons/jiaoqiu.png');
const ICON4 = require('../../../images/icons/jinqiu.png');
const ICON5 = require('../../../images/icons/dianqiu.png');
const ICON6 = require('../../../images/icons/huanren.png');
const ICON7 = require('../../../images/icons/lianghuanyihong.png');
const ICON8 = require('../../../images/icons/dianqiuweijin.png');
const ICON9 = require('../../../images/icons/wulong.png');
const ICON10 = require('../../../images/icons/zhugong.png');



const ICONS_NAME_DATA = [
    { icon: ICON4, name: '进球' },
    { icon: ICON5, name: '点球' },
    { icon: ICON8, name: '点球未进' },
    { icon: ICON9, name: '乌龙' },
    { icon: ICON10, name: '助攻' },
    { icon: ICON3, name: '角球' },
    { icon: ICON1, name: '黄牌' },
    { icon: ICON2, name: '红牌' },
    { icon: ICON6, name: '换人' },
    { icon: ICON7, name: '两黄一红' },
]


class MovieStateFootball extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            value: 0,
            matchData: null,
            stats: [],
            showdetail: false,
            tlive: [],
        };
        console.log('MovieStateFootball', props);
    }

    componentDidMount() {
        this.getFootboolRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getFootboolRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;
        if (matchType == 0 && data) {
            matchType = data.match_type;
        }
        if (matchId == 0 && data) {
            matchId = data.match_id;
        }

        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('getFootboolRealtimeData', result);
        if (result.code == 200) {
            let statsMap = [];
            let stats = result.data.stats;
            if (stats) {
                for (let i = 0; i < stats.length; i++) {
                    statsMap[stats[i].type] = stats[i];
                }
            }
            let tlive = [];
            if (result.data.tlive) {
                tlive = result.data.tlive.reverse()
            }
            this.setState({
                matchData: result.data,
                stats: statsMap,
                tlive: tlive,
            });
        }
    }

    _handleChange = (value) => {
        this.setState({ value: value });
    }

    _handleShow() {
        this.setState({ showdetail: !this.state.showdetail });
    }

    _onClickAd = (url) => {
        OpenBrowser(url);
    }

    render() {
        const { classes, data } = this.props;
        const { value, matchData, showdetail, stats, tlive } = this.state;
        let atackHome = stats[23] && stats[23].home ? stats[23].home : 0;
        let atackAway = stats[23] && stats[23].away ? stats[23].away : 0;
        let dangerousatackHome = stats[24] && stats[24].home ? stats[24].home : 0;
        let dangerousatackAway = stats[24] && stats[24].away ? stats[24].away : 0;
        let ballPossessionHome = stats[25] && stats[25].home ? stats[25].home : 0;
        let ballPossessionAway = stats[25] && stats[25].away ? stats[25].away : 0;
        let huangPaiHome = stats[3] && stats[3].home ? stats[3].home : 0;
        let huangPaiAway = stats[3] && stats[3].away ? stats[3].away : 0;
        let hongPaiHome = stats[4] && stats[4].home ? stats[4].home : 0;
        let hongPaiAway = stats[4] && stats[4].away ? stats[4].away : 0;
        let jiaoqiuHome = stats[2] && stats[2].home ? stats[2].home : 0;
        let jiaoqiuAway = stats[2] && stats[2].away ? stats[2].away : 0;
        let shengzhenHome = stats[21] && stats[21].home ? stats[21].home : 0;
        let shengzhenAway = stats[21] && stats[21].away ? stats[21].away : 0;
        let shengPianHome = stats[22] && stats[22].home ? stats[22].home : 0;
        let shengPianAway = stats[22] && stats[22].away ? stats[22].away : 0;

        let liveSheZhengHome = (shengzhenHome + shengzhenAway) == 0 ? 0 : (shengzhenHome / (shengzhenHome + shengzhenAway)).toFixed(2);
        let liveSheZhengAway = (shengzhenHome + shengzhenAway) == 0 ? 0 : (shengzhenAway / (shengzhenHome + shengzhenAway)).toFixed(2);
        liveSheZhengHome = liveSheZhengHome * 100;
        liveSheZhengAway = liveSheZhengAway * 100;

        let liveShePianHome = (shengPianHome + shengPianAway) == 0 ? 0 : (shengPianHome / (shengPianHome + shengPianAway)).toFixed(2);
        let liveShePianAway = (shengPianHome + shengPianAway) == 0 ? 0 : (shengPianAway / (shengPianHome + shengPianAway)).toFixed(2);
        liveShePianHome = liveShePianHome * 100;
        liveShePianAway = liveShePianAway * 100;

        let ad_img = AppData.ServerConfig.ad_img;
        let ad_url = AppData.ServerConfig.ad_url;

        let { showAd } = this.props

        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                {showAd && <Grid style={{ width: '100%', backgroundColor: '#FFF' }}>
                    <img src={ad_img} className={classes.adImg} onClick={() => this._onClickAd(ad_url)} ></img>
                </Grid>}
                <Grid container direction='row' alignItems='center' style={{ width: '100%', marginTop: 16, backgroundColor: '#FFF' }}>
                    <Grid container direction='row' alignItems='center' style={{ maxWidth: '50%' }} >
                        <MDivider width={3} height={9} backgroundColor='#FC2E34' borderRadius={1.5} marginH={8}></MDivider>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{data ? data.home_name : ''}</Typography>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1 }}>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{data ? data.away_name : ''}</Typography>
                        <MDivider width={3} height={9} backgroundColor='#368CF4' borderRadius={1.5} marginH={8}  ></MDivider>
                    </Grid>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='space-around' style={{ marginTop: 16, marginBottom: 8 }}>
                    <ChartCircle score1={atackHome} score2={atackAway} title='进攻' />
                    <ChartCircle score1={dangerousatackHome} score2={dangerousatackAway} title='危险进攻' />
                    <ChartCircle score1={ballPossessionHome} score2={ballPossessionAway} title='控球率' />
                </Grid>
                <Grid style={{ backgroundColor: '#E1E1E1', width: '100vw', height: 1 }}></Grid>
                <Grid container direction='column' alignItems='center' justifyContent='center' style={{ marginLeft: 8, marginRight: 8, marginTop: 16, width: 'calc(100vw - 16px)' }}>
                    <Grid container direction='row' alignItems='center' justifyContent='center'>
                        <Grid container direction='column' alignItems='center' justifyContent='flex-end' style={{ flex: 1 }}>
                            <Grid container direction='row' alignItems='center'  >
                                <img src={ICON1} style={{ width: 10, height: 12.5, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{huangPaiHome}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center'>
                                <img src={ICON2} style={{ width: 10, height: 12.5, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{hongPaiHome}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center'>
                                <img src={ICON3} style={{ width: 10, height: 10, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{jiaoqiuHome}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container direction='column' alignItems='center' justifyContent='center' style={{ width: '70%' }}>
                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                <Typography style={{ fontSize: 10, color: '#898989' }}>射正球门</Typography>
                                <Grid container direction='row' alignItems='center' justifyContent='center'>
                                    <Typography style={{ fontSize: 10, color: '#0D0D0D', marginRight: 4 }}>{shengzhenHome}</Typography>
                                    <Grid container alignItems='center' justifyContent='flex-end' style={{ backgroundColor: '#F0F0F0', height: 4, width: '40%' }}>
                                        <Grid container alignItems='center' style={{ backgroundColor: '#FC2D33', width: liveSheZhengHome + '%', height: 4 }}></Grid>
                                    </Grid>
                                    <Grid style={{ width: 2 }}></Grid>
                                    <Grid container alignItems='center' justifyContent='flex-start' style={{ backgroundColor: '#F0F0F0', height: 4, width: '40%' }}>
                                        <Grid container alignItems='center' style={{ backgroundColor: '#FC2D33', width: liveSheZhengAway + '%', height: 4 }}></Grid>
                                    </Grid>
                                    <Typography style={{ fontSize: 10, color: '#0D0D0D', marginLeft: 4 }}>{shengzhenAway}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container direction='column' alignItems='center' justifyContent='center'>
                                <Typography style={{ fontSize: 10, color: '#898989' }}>射偏球门</Typography>
                                <Grid container direction='row' alignItems='center' justifyContent='center'>
                                    <Typography style={{ fontSize: 10, color: '#0D0D0D', marginRight: 4 }}>{shengPianHome}</Typography>
                                    <Grid container alignItems='center' justifyContent='flex-end' style={{ backgroundColor: '#F0F0F0', height: 4, width: '40%' }}>
                                        <Grid container alignItems='center' style={{ backgroundColor: '#FC2D33', width: liveShePianHome + '%', height: 4 }}></Grid>
                                    </Grid>
                                    <Grid style={{ width: 2 }}></Grid>
                                    <Grid container alignItems='center' justifyContent='flex-start' style={{ backgroundColor: '#F0F0F0', height: 4, width: '40%' }}>
                                        <Grid container alignItems='center' style={{ backgroundColor: '#FC2D33', width: liveShePianAway + '%', height: 4 }}></Grid>
                                    </Grid>
                                    <Typography style={{ fontSize: 10, color: '#0D0D0D', marginLeft: 4 }}>{shengPianAway}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container direction='column' alignItems='center' justifyContent='center' style={{ maxWidth: 50, flex: 1 }}>
                            <Grid container direction='row' alignItems='center'>
                                <img src={ICON1} style={{ width: 10, height: 12.5, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{huangPaiAway}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center'>
                                <img src={ICON2} style={{ width: 10, height: 12.5, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{hongPaiAway}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center'>
                                <img src={ICON3} style={{ width: 10, height: 10, marginTop: 4 }}></img>
                                <Typography style={{ fontSize: 10, color: '#878787', marginTop: 4, marginLeft: 4 }}>{jiaoqiuAway}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction='column' alignItems='center' justifyContent='center' style={{ marginTop: 8 }}>
                        {
                            showdetail && stats.map((item, i) => (
                                <MBasketChartItem
                                    key={i} score1={item.home}
                                    score2={item.away}
                                    midtitle={DataUtils.getType(item.type)}
                                    allscore1={item.home + item.away}
                                    allscore2={item.home + item.away} />
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid style={{ backgroundColor: '#E1E1E1', width: '100%', height: 1 }}></Grid>
                <Grid container direction='row' alignItems='center' justifyContent='center' style={{ marginTop: 4, marginBottom: 4 }} >
                    <ButtonBase className={classes.buttonBase} onClick={() => this._handleShow()}>
                        <Typography style={{ fontSize: 10, color: '#898989' }}>{showdetail ? '收起' : '全部统计'}</Typography>
                        {
                            showdetail ? <ExpandLessIcon style={{ fontSize: 10, color: '#898989' }} /> : <ExpandMoreIcon style={{ fontSize: 10, color: '#898989' }} />
                        }
                    </ButtonBase>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='center' style={{ paddingTop: 16, paddingBottom: 16, backgroundColor: '#F7F7F7' }} >
                    <MTabsButton data={['文字直播', '重要事件']} onChange={(value) => this._handleChange(value)} />
                </Grid>
                <Grid style={{ width: '100%', backgroundColor: '#F7F7F7' }}>
                    <MTabPanel value={value} index='0' style={{ width: '100%' }}>
                        <MovieStateFootBallTextLive data={tlive ? tlive : []} />
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100%' }}>
                        <MovieStateFootBallStatistics data={data} />
                    </MTabPanel>
                </Grid>
                <Grid container direction='row' alignItems='center' style={{ width: '100%', backgroundColor: '#F7F7F7', paddingLeft: 16, paddingRight: 16, paddingTop: 16 }}>
                    {
                        ICONS_NAME_DATA.map((item, i) => (
                            <Grid key={i} container direction='row' alignItems='center' style={{ maxWidth: 78, marginTop: 4, marginBottom: 4 }}>
                                <img src={item.icon} style={{ width: 10, height: 12.5, objectFit: 'scale-down' }}></img>
                                <Typography style={{ fontSize: '#0D0D0D', fontSize: 10, marginLeft: 4, maxWidth: 56 }}>{item.name}</Typography>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF',
    },
    buttonBase: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    },
    adImg: {
        width: 'calc(100vw - 16px)',
        height: 100,
        marginLeft: 8,
        marginTop: 8,
    }
}))(MovieStateFootball));